import React, { FC } from 'react';

interface IProps {
  className?: string;
}
export const ExportIconSVG: FC<IProps> = props => {
  const { className } = props;
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M10.0625 10.5C10.2812 10.5 10.5 10.7188 10.5 10.9375V12.25C10.5 13.2344 9.70703 14 8.75 14H1.75C0.765625 14 0 13.2344 0 12.25V1.75C0 0.792969 0.765625 0 1.72266 0H5.82422C6.28906 0 6.72656 0.191406 7.05469 0.519531L9.98047 3.44531C10.3086 3.77344 10.5 4.21094 10.5 4.67578V6.5625C10.5 6.80859 10.2812 7 10.0625 7C9.81641 7 9.625 6.80859 9.625 6.5625V5.25H6.5625C5.82422 5.25 5.25 4.67578 5.25 3.9375V0.875H1.75C1.25781 0.875 0.875 1.28516 0.875 1.75V12.25C0.875 12.7422 1.25781 13.125 1.75 13.125H8.75C9.21484 13.125 9.625 12.7422 9.625 12.25V10.9375C9.625 10.7188 9.81641 10.5 10.0625 10.5ZM6.125 0.957031V3.9375C6.125 4.18359 6.31641 4.375 6.5625 4.375H9.54297C9.51562 4.26562 9.46094 4.15625 9.35156 4.04688L6.45312 1.14844C6.34375 1.03906 6.23438 0.984375 6.125 0.957031Z" />
      <path d="M6 8.65C5.8067 8.65 5.65 8.8067 5.65 9C5.65 9.1933 5.8067 9.35 6 9.35V8.65ZM13.7475 9.24749C13.8842 9.1108 13.8842 8.8892 13.7475 8.75251L11.5201 6.52513C11.3834 6.38844 11.1618 6.38844 11.0251 6.52513C10.8884 6.66181 10.8884 6.88342 11.0251 7.0201L13.005 9L11.0251 10.9799C10.8884 11.1166 10.8884 11.3382 11.0251 11.4749C11.1618 11.6116 11.3834 11.6116 11.5201 11.4749L13.7475 9.24749ZM6 9.35L13.5 9.35V8.65L6 8.65V9.35Z" />
    </svg>
  );
};

export default ExportIconSVG;
